import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getMedicalConsultSelector } from '../selectors'
import { saveMedicalConsult } from '../store/medicalConsult.actions'
import { MedicalConsultConstants } from '../store/medicalConsult.constants'
import { IMedicalConsultState } from '../store/medicalConsult.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setComments() {
  const medicalConsultState: IMedicalConsultState = yield select(getMedicalConsultSelector)
  const { comments } = medicalConsultState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.medicalConsultStateList && pcrDoc.patient?.medicalConsultStateList.length) {
        const index = pcrDoc.patient?.medicalConsultStateList?.findIndex(
          (medicalConsult) => medicalConsult.key === medicalConsultState.key
        )
        if (index !== -1) {
          if (pcrDoc.patient.medicalConsultStateList[index].comments !== comments) {
            yield put(saveMedicalConsult())
          }
        }
      } else {
        yield put(saveMedicalConsult())
      }
    } catch (e) {
      yield put(throwPcrException(`setComments() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCommentsSaga() {
  yield takeLatest([MedicalConsultConstants.SET_COMMENTS], performWithMutexHOG, setComments)
}
